<section class="institutional">
    <div class="institutional-header">
        <h1 class="institutional-header__title">
            Política de Privacidade
        </h1>
    </div>
    <div class="institutional-content">
        <div class="text">
            <div class="indication">
                <div class="indication-item">
                    <a pageScroll href="#titulo1">
                        1. A quem se destina o aplicativo IMMOBILE
                    </a>
                </div>
                <div class="indication-item">
                    <a pageScroll href="#titulo2">
                        2. Da Coleta de Dados e sua finalidade
                    </a>
                </div>
                <div class="indication-item">
                    <a pageScroll href="#titulo3">
                        3. DOS REQUISITOS
                    </a>
                </div>
                <div class="indication-item">
                    <a pageScroll href="#titulo4">
                        4. Do Tempo em que os Dados Pessoais são Armazenados
                    </a>
                </div>
                <div class="indication-item">
                    <a pageScroll href="#titulo5">
                        5. Da Base Legal para o Tratamento de Dados Pessoais
                    </a>
                </div>
                <div class="indication-item">
                    <a pageScroll href="#titulo6">
                        6. Do Controlador
                    </a>
                </div>
                <div class="indication-item">
                    <a pageScroll href="#titulo7">
                        7. Dos meios de Contato
                    </a>
                </div>
            </div>
            <div class="text-section">
                <p>
                    Abaixo, o IMMOBILE LTDA. (IMMOBILE), pessoa jurídica de
                    direito privado, inscrita no CNPJ sob no 39.502.698/0001-89, com sede na Rua Angelino Gazzola, no
                    136, ap. 05, Caxias do Sul/RS, CEP 95074-803, dispõe os seus Termos de Privacidade, em consonância
                    com a Lei Geral de Proteção de Dados Pessoais (LGPD) – Lei no. 13.709/2018.
                </p>
            </div>
            <div class="text-section">
                <h3 id="titulo1">
                    1 A quem se destina o aplicativo IMMOBILE</h3>
                <p>
                    1.1 O aplicativo IMMOBILE deve ser utilizado por pessoas maiores de 18 anos, ressalvadas as
                    hipóteses legais de emancipação.
                </p>
                <p>
                    1.2 O IMMOBILE é uma plataforma de intermediação de fretes e carretos, com facilitação de
                    pagamento, mediante licença de utilização do aplicativo, que permite ao usuário cadastrado localizar
                    e contatar motoristas autônomos, também previamente cadastrados, interessados em realizar o referido
                    transporte.
                </p>
                <p>
                    1.3 Ao se cadastrar junto ao aplicativo IMMOBILE, ao usuário/motorista serão apresentados a
                    presente Política de Privacidade e os Termos de Uso. Ao aceitá-los, o usuário declara ter lido e
                    estar ciente de todo o seu conteúdo, firmando o compromisso de cumprir com rigor todas as condições
                    estabelecidas.
                </p>
                <p>
                    1.4 A Política de Privacidade poderá, a qualquer momento, ser alterada/atualizada, sem a necessidade
                    de prévio aviso, mas imediatamente disponibilizada na plataforma, sendo de responsabilidade
                    exclusiva do usuário/motorista a leitura periódica dela.
                </p>
                <p>
                    1.5 Presumem-se aceitos os Termos eventualmente alterados/atualizados, se após a sua publicação na
                    plataforma o usuário permanecer utilizando o aplicativo.
                </p>
                <p>
                    1.6 Se o usuário discordar das alterações na Política de Privacidade, deverá requerer o cancelamento
                    da sua conta junto ao aplicativo IMMOBILE, o que o excluirá da aplicação tecnológica.
                </p>

            </div>
            <div class="text-section">
                <h3 id="titulo2">2 Da Coleta de Dados e sua finalidade</h3>
                <p>
                    2.1 O usuário que desejar contratar motoristas autônomos transportadores por intermédio do
                    aplicativo IMMOBILE, deverá cadastrar os seus dados pessoais, quais sejam o nome, telefone,
                    e-mail, CPF/CNPJ, Inscrição Estadual e endereço, bem como informar dados do cartão de crédito, se
                    esta for a forma de pagamento escolhida, além de quaisquer outros que porventura a aplicação
                    tecnológica necessitar e requerer.
                </p>
                <p>
                    2.2 O motorista que desejar operar os seus serviços por intermédio do aplicativo IMMOBILE, deverá
                    cadastrar os seus dados pessoais, quais sejam o nome,
                    telefone, e-mail, CPF/CNPJ, Inscrição Estadual, endereço, dados do(s) seu(s) veículo(s) e número de
                    conta bancária, além de quaisquer outros que porventura a aplicação tecnológica necessitar e
                    requerer.
                </p>
                <p>
                    2.3 O usuário/motorista está ciente que o IMMOBILE não tem qualquer acesso ao login de
                    usuário/motorista, de modo que as informações cadastrais são as inscritas pelo próprio no momento do
                    cadastro.
                </p>
                <p>
                    2.4 Os dados cadastrais são coletados no momento em que o usuário/motorista se cadastra e/ou altera
                    os seus dados e cria um login de acesso à aplicação tecnológica.
                </p>
                <p>

                    2.5 Referidos dados são coletados com a finalidade de garantir a segurança dos usuários/motoristas,
                    facilitar as transações, dar suporte ao cliente, para pesquisa e desenvolvimento, permitir a
                    comunicação entre os usuários e motoristas, enviar comunicados aos usuários/motoristas e para
                    utilizá-los em procedimentos jurídicos.
                </p>
                <p>
                    2.6 O IMMOBILE poderá utilizar os dados fornecidos pelo motorista para consultar os antecedentes
                    seus criminais, bem como a situação do(s) veículo(s), além de realizar quaisquer outras verificações
                    necessárias e/ou exigíveis pela legislação brasileira, inclusive solicitar outros documentos.
                </p>
                <p>
                    2.7 Além dos dados cadastrais fornecidos pelo usuário/motorista, o IMMOBILE coleta e armazena
                    dados relativos aos endereços de coleta e entrega dos objetos transportados, com a finalidade de
                    garantir a segurança e a melhor prestação dos serviços.
                </p>
                <p>
                    2.8 O IMMOBILE também coleta dados de localização do motorista em primeiro plano e em segundo
                    plano. Ou seja, mesmo com o aplicativo minimizado, o IMMOBILE coleta os dados da localização em
                    tempo real, com as seguintes finalidades:
                </p>
                <ul>
                    <li>
                        a) ofertar para o motorista serviços próximos a ele (ainda que o aplicativo esteja minimizado);
                    </li>
                    <li>
                        b) garantir que o motorista só inicie a corrida quando estiver no ponto de coleta;
                    </li>
                    <li>
                        c) garantir que o motorista finalize a entrega somente quando estiver no ponto de entrega;
                    </li>
                    <li>
                        d) para que o usuário, contratante do serviço, possa acompanhar em tempo real a localização da
                        sua carga (ainda que o aplicativo esteja minimizado).
                    </li>
                </ul>
                <p>
                    2.9 O IMMOBILE coleta também os dados relativos às transações por meio do aplicativo, data e hora
                    em que o serviço foi prestado, valor cobrado, distância percorrida e forma de pagamento, sempre com
                    a finalidade de apresentar os históricos ao usuário/motorista, bem como para permitir o constante
                    aprimoramento do serviço.
                </p>
                <p>
                    2.10 O IMMOBILE permite que usuários e motorista se comuniquem entre si dentro do aplicativo,
                    sempre com a finalidade de facilitar a contratação e prestação do serviço.
                </p>
                <p>
                    2.11 O IMMOBILE usa cookies na sua aplicação tecnológica, para o fim de autenticar
                    usuários/motoristas, determinar a popularidade de um conteúdo, veicular e medir a eficácia de
                    campanhas de marketing e analisar tendências e comportamentos.
                </p>
                <p>
                    2.12 Após a realização de cada serviço, usuário e motorista podem realizar a avaliação um em relação
                    ao outro, de modo que a média dessas avaliações é associada à conta do usuário/motorista e exibida
                    aos outros usuários/motoristas para os quais oferece ou dos quais recebe serviços.
                </p>
            </div>
            <div class="text-section">
                <h3 id="titulo3">3 DOS REQUISITOS</h3>
                <p>
                    3.1 Para utilizar o aplicativo IMMOBILE o usuário deve ter idade igual ou superior a 18 anos,
                    ressalvadas as hipóteses legais de emancipação e ter capacidade civil, na forma da legislação
                    brasileira.
                </p>
            </div>
            <div class="text-section">
                <h3 id="titulo3">3 Do Compartilhamento de Dados Pessoais com Terceiros</h3>
                <p>
                    3.1 O IMMOBILE não vende nem compartilha dados pessoais dos usuários/motoristas com terceiros,
                    exceto com o seu consentimento. Apesar disso, é possível que o faça para cumprir alguma determinação
                    legal ou regulatória, ou, ainda, para cumprir alguma ordem expedida por autoridade pública.
                </p>
            </div>
            <div class="text-section">
                <h3 id="titulo4">4 Do Tempo em que os Dados Pessoais são Armazenados</h3>
                <p>
                    4.1 O IMMOBILE mantém os dados pessoais do usuário/motorista pelo tempo necessário à realização
                    dos fins descritos acima, podendo, entretanto, o usuário/motorista requerer a exclusão da sua conta
                    a qualquer momento, ressalvando-se os casos em que houver a possibilidade ou a necessidade de
                    armazenamento em virtude de disposição legal ou regulatória.
                </p>
            </div>
            <div class="text-section">
                <h3 id="titulo5">5 Da Base Legal para o Tratamento de Dados Pessoais</h3>
                <p>
                    5.1 O tratamento de dados pessoais constante da Política de Privacidade do IMMOBILE tem
                    fundamento jurídico na Lei Geral de Proteção de Dados Pessoais – Lei no 13.709/2018.
                </p>
            </div>
            <div class="text-section">
                <h3 id="titulo6">6 Do Controlador</h3>
                <p>
                    De acordo com a Lei no 13.709/2018, o controlador do aplicativo IMMOBILE e responsável pelo
                    tratamento de dados pessoais é o GRUPO LOGÍSTICO MAIZ INTERMEDIAÇÕES DE TRANSPORTES LTDA. (MAIZ
                    CARGAS), pessoa jurídica de direito privado, inscrita no CNPJ sob no 39.502.698/0001-89, com sede na
                    Rua Angelino Gazzola, no 136, ap. 05, Caxias do Sul/RS, CEP 95074- 803.
                </p>
            </div>
            <div class="text-section">
                <h3 id="titulo7">7 Dos meios de Contato</h3>
                <p>
                    Para esclarecer quaisquer dúvidas sobre esta Política de Privacidade ou sobre os dados pessoais que
                    o IMMOBILE trata, o usuário/motorista deve entrar
                    em contato com o Encarregado de Proteção de Dados Pessoais, por algum dos canais mencionados abaixo:
                    <br />
                    E-mail: <a href="mailto:contato@maizcargas.com.br">contato@maizcargas.com.br</a>
                    <br />
                    Endereço Postal: Rua Angelino Gazzola, no 136, ap. 05, Caxias do Sul/RS, CEP 95074-803
                </p>
            </div>
        </div>
    </div>
</section>